const menuHU = {
    "add_to_cart": "Hozzáadás a kosárhoz",
    "add_to_order": "Hozzáadás a rendeléshez",
    "already_in_cart": "Már a kosaradban",
    "update_order_item": "Tétel frissítése",
    "delete_order_item": "Tétel eltávolítása",
    "available_categories": "Menü kategóriák",
    "search_menu_placeholder": "Keresés a menüben",
    "guides": {
        "scan_qr": "Scanneld be az asztalon lévő QR kódot a telefonoddal",
        "order": "Rendeld meg a telefonodról a kiválasztott termékeket",
        "pay": "Fizessetek külön vagy egyben a telefonodról",
        "accept": "Tovább az étlapra",
    },
    "index_image": "Indexkép",
    "menu_saved": "Menü mentve",
    "new_category": "Új kategória",
    "menu_editor": "Étlap szerkesztő",
    "new_item": "Új tétel",
    "menu": "Étlap",
    "generate_qr": "QR kód generálása",
    "allergens": "Allergének",
    "allergen_list": {
        "gluten": "Glutén",
        "crustaceans": "Rákfélék",
        "eggs": "Tojás",
        "fish": "Hal",
        "peanuts": "Földimogyoró",
        "soybeans": "Szójabab",
        "milk": "Tej",
        "nuts": "Diófélék",
        "celery": "Zeller",
        "mustard": "Mustár",
        "sesame": "Szezámmag",
        "sulphur_dioxide": "Kén-dioxid",
        "lupin": "Lupin",
        "molluscs": "Puhatestűek",
        "vegan": "Vegán"
    },
    "add_allergen": "Allergén hozzáadása",
    "auto_translate": "Menü fordítás",
    "no_category_name": "Nincs kategória név megadva a jelenlegi nyelven",
    "no_item_name": "Nincs tétel név megadva a jelenlegi nyelven",

    "category_and_items_language": "Kategória és tételek nyelve",
    "auto_translate_title": "Az automatikus menü fordítást csak a már elmentett kategóriák és tételekre lehet alkalmazni. A kezdeti nyelv kitöltése ajánlott.",
    "auto_translate_description": "Ez a funkció a Google Translate szolgáltatást használja. A fordítások nem mindig pontosak, ezért érdemes ellenőrizni őket.",
    "translate_from": "Fordítás erről",
    "translate_to": "Ezekre a nyelvekre",
    "auto_translate_error_invalid_languages": "Érvénytelen nyelv lett kiválasztva a fordításhoz",
    "auto_translate_success": "Menü sikeresen lefordítva",
    "auto_translate_error_permission": "Nincs jogosultságod a menü fordítására",
    "auto_translate_error_generic": "Ismeretlen hiba történt a fordítás során",
    "auto_translate_feature_not_available": "Az automatikus menü fordítás csak PRO előfizetéssel érhető el.",
    "change_subscription_plan": "Előfizetés módosítása",

    "menu_headers": "Menü fej- és lábléc",
    "menu_header_editor_title": "Menü fejléc és lábléc az online menü tetején és alján megjelenő szövegek, amiket szabadon megadhatsz.",
    "menu_header_feature_not_available": "A menü fejléc és lábléc szerkesztése csak PRO előfizetéssel érhető el.",
    "menu_header": "Menü fejléc",
    "menu_header_placeholder": "Írj egy rövid üdvözlő üzenetet vagy emelj ki egy aktuális ajánlatot",
    "menu_footer": "Menü lábléc",
    "menu_footer_placeholder": "Megadhatsz információt a szervizdíjról, allergénekről vagy más fontos tudnivalóról",
    "menu_header_save_success": "Menü fejléc és lábléc sikeresen mentve",
    "menu_header_save_error": "Hiba történt a menü fejléc és lábléc mentésekor",
    "menu_header_permission_error": "Nincs jogosultságod a menü fejléc és lábléc szerkesztésére",
    "menu_header_generic_error": "Ismeretlen hiba történt a menü fejléc és lábléc betöltésekor",
    "menu_import": "Menü importálás",
    "import_success": "Az előző menü import sikeresen befejeződött",
    "import_failed": "Az előző menü import szerver oldali hiba miatt sikertelenül zárult",
    "attached_document": "Csatolt dokumentum",
    "allowed_file_types": "Engedélyezett fájl típusok",
    "import_language_helpertext": "Dokumentum nyelve",
    "import_options_pro_helpertext": "Az 'Inaktiválás' és 'Hozzáadás' opciók csak a PRO előfizetéssel érhetők el.",
    "import_option_helpertexts": {
        "replace": "A jelenlegi menü le lesz cserélve az újonnan generált menüre.",
        "deactivate": "A jelenlegi menü kategóriák és tételek inaktiválva lesznek, az újonnan generált menü pedig hozzáadásra kerül.",
        "add": "A jelenlegi menü megmarad, az új menü tételek pedig jelenlegi menü után lesznek rögzítve.",
    },
    "import_type": "Import módja",
    "import_options": {
        "replace": "Csere",
        "deactivate": "Inaktiválás",
        "add": "Hozzáadás",
    },
    "menu_import_tooltip": " Töltsd fel az étterem menüjét tartalmazó fájlt, vagy add meg a menüt tartalmazó webhely linkjét. Mindkét esetben ügyelj arra, hogy a menü szövegesen elérhető legyen a dokumentumban, képeket ugyanis nem tudunk feldolgozni. Az import indítása után a mesterséges intelligenciánk automatikusan feldolgozza a fájlt és létrehozza az új menüt a kiválasztott nyelven. Ha később több nyelvre is szeretnéd lefordítani a tételeket, használd a 'Menü fordítás' funkciót! Az importálás folyamat 5 - 10 percet vesz igénybe.",
    "menu_import_replace_warning": "A jelenleg kiválasztott importálási mód törölni fogja a jelenlegi menüt és kicseréli az új menüre. Kérlek győzödj meg róla, hogy a feltöltött fájl megfelelő formátumú és tartalmú, mert a művelet visszafordíthatatlan! Ha nem szeretnéd törölni a jelenlegi menüt, kérlek válassz másik importálási módot.",
    "start_import": "Importálás",
    "file_or_url_required": "Kérlek válassz fájlt vagy adj meg egy URL-t",
    "file_and_url_error": "Egyszerre csak fájlt vagy URL-t adhatsz meg, mindkettőt nem",
    "import_site_url": "Weboldal URL",
    "import_in_progress": "Importálás folyamatban",
    "import_duration": "Ez eltarthat néhány percig",
    "listing_manager_info": {
        "summary": "A Mozrest segítségével egyetlen platformról könnyedén kezelheti hirdetéseit és értékeléseit.Takarítson meg időt, javítsa online hírnevét, és növelje a működési hatékonyságát.",
        "bullet_1": "Azonnal frissítheti profiljait a Tripadvisoron, az Apple Maps-en, a Google-on, a Facebookon, a Quandóón és a Bingen, mindössze egyetlen kattintással.",
        "bullet_2": "Valós idejű értesítéseket kaphat, ha a nyitvatartási ideje és a szabad helyek nem egyeznek, megelőzve ezzel a vendégek csalódottságát és a negatív visszajelzéseket.",
        "bullet_3": "Gyorsan ellenőrizheti profiljának teljességét, hogy minden fontos részlet – mint a képek, menük és a nyitvatartás – pontos és naprakész legyen.",
        "setup_button": "Mozrest beállítása",
        "pro_warning": "Ennek a funkciónak a használatához PRO előfizetésre van szükség."
    },
    "listing_manager_tabs": {
        "Listing": "Hirdetés",
        "ListingAnalytics": "Hirdetés elemzés",
        "ReviewsPage": "Vélemények",
        "ReviewAnalytics": "Vélemény elemzés",
        "ReplyTemplates": "Válasz sablonok",
        "Notifications": "Értesítések"
    },
    "review_manager_set_title": "Review manager beállítása",
    "review_manager_set_description": "Kérlek adj meg néhány információt a vállalkozásodról, hogy létrehozhassuk az alapbeállításaidat",
    "confirm_settings": "Beállítások megerősítése",
    "confirm_delete_item": "Törlöd a tételt?",
    "confirm_delete_category": "Törlöd a kategóriát és az összes tételét?",
    "reorder_disabled_search": "Keresés közben az átrendezés nem elérhető",
}

export default menuHU;